export class HideImage {
    hideImageSpeaker: boolean = false;
    hideImageOrganizer: boolean = false;
    hideImageSponsor: boolean = false;
    hideImageExhibitor: boolean = false;

}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/hideImage.ts